import React, { PureComponent } from 'react';
import { ToolbarGroup } from './toolbar-group.js';
import { ToolbarButtonDivider } from '../buttons/toolbar-button-divider.js';
import { DEFAULT_SHELTER_ICON } from '../constants/default-shelter-icon.js';
import { TOOLBAR_OVERALL_SHELTER_NAME } from '../constants/shelter-button.js';

class ToolbarRenderer extends PureComponent {
    render() {
        const { groups, addShelter, breakAll, tooltipPlacement, } = this.props;
        return groups.filter(group => group.items.length > 0)
            .map((group) => {
            const shelterButton = group.shelter && addShelter
                ? React.createElement(ToolbarGroup, { key: `group-shelter-${group.shelter.name}`, group: [[group.shelter]], tooltipPlacement: tooltipPlacement })
                : null;
            const isFlatGroup = group.items.every(item => item.buttons.length === 1);
            // 实体组中的每个虚拟组都仅有一行，可合并相邻无 shelter 的虚拟组
            if (isFlatGroup && !breakAll) {
                let newGroup = false;
                return group.items.reduce((acc, item) => {
                    const lastItem = acc[acc.length - 1];
                    if (newGroup || !lastItem || item.shelter) {
                        const newItem = Object.assign(Object.assign({}, item), { buttons: item.buttons.map(row => [...row]) });
                        acc.push(newItem);
                        if (item.shelter && addShelter) {
                            newItem.buttons[0] = item.buttons[0].concat(item.shelter);
                        }
                    }
                    else {
                        lastItem.buttons[0] = lastItem.buttons[0].concat(item.buttons[0]);
                    }
                    newGroup = !!item.shelter;
                    return acc;
                }, [])
                    .map(item => React.createElement(ToolbarGroup, { key: item.key, group: [item.buttons[0]], tooltipPlacement: tooltipPlacement }))
                    .concat(shelterButton);
            }
            // 每个 item 为一个虚拟组，group 为实体组
            return group.items.flatMap((item) => {
                if (isFlatGroup && breakAll && item.buttons[0].length > 1) {
                    return item.buttons[0].map((button, index) => React.createElement(ToolbarGroup, { key: `${item.key}-${index}`, group: [[button]], shelter: (addShelter && index === item.buttons[0].length - 1) ? item.shelter : null, tooltipPlacement: tooltipPlacement }));
                }
                return React.createElement(ToolbarGroup, { key: item.key, group: item.buttons, shelter: addShelter ? item.shelter : null, tooltipPlacement: tooltipPlacement });
            }).concat(shelterButton);
        })
            // 为每个实体组添加分隔线，并打平虚拟组
            .flatMap((group, index, array) => [
            group,
            index !== array.length - 1 || !addShelter
                ? React.createElement(ToolbarButtonDivider, { id: `toolbar-group-divider-${index}`, key: `toolbar-group-divider-${index}` })
                : React.createElement(ToolbarGroup, { key: "overall-shelter", group: [[{
                                name: TOOLBAR_OVERALL_SHELTER_NAME,
                                icon: DEFAULT_SHELTER_ICON,
                                badge: false,
                                force: 0,
                                hasArrow: false,
                                text: this.props.moreText,
                                dropdownContent: () => null,
                            }]], tooltipPlacement: tooltipPlacement }),
        ]);
    }
}

export { ToolbarRenderer };
//# sourceMappingURL=toolbar-renderer.js.map
